import { config } from "../config";

export const logMetaDedup = (event: string, details: Record<string, unknown>): void => {
  if (!config.metaDedupDebug) {
    return;
  }

  console.log(`[meta-dedup] ${event}`, details);
};
